import React from 'react';

import TermsAndPolicyLabel from '../../term-and-policy/TermsAndPolicyLabel';
import UserNotificationSettings from '../../user-notification-settings/UserNotificationSettings';

import './DefaultFormFooterHint.scss';

const DefaultFormFooterHint = () => (
  <div className="form-footer-hint">
    <TermsAndPolicyLabel />
    <UserNotificationSettings />
  </div>
);

export default DefaultFormFooterHint;
